<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
<div>
  <router-link :to="{name: 'forum', params: {id: news.textParams[0]}}"
  >{{news.textParams[1]}}</router-link>
  {{$t('news.template.forum.candidateValNew.p1')}}
  {{news.textParams[2]}}
  {{$t('news.template.forum.candidateValNew.p2')}}
  {{news.textParams[3]}}
  {{news.textParams[4]}}!
</div>
</template>
